import React, { useState } from 'react';

import ModalContentWrapper from "./Modals/ModalContentWrapper";

import { setPrivacyRead } from "root/DataFunctions/LoginFns";
import {getVariant, VariantString} from "root/textVariants";

import './ModalPrivacyStatement.scss';

const ModalPrivacyStatement = ({onClose, authority_id} ) =>
{
    const [ closeAllowed, setCloseAllowed ] = useState ( true ) ;
    const [ buttonState, setButtonState ] = useState ( '' ) ;

    const doSetPrivacyRead = () =>
    {
        setPrivacyRead((response) => {
            onClose() ;
        }) ;
    }

    const onClickCancel = () =>
    {
        if ( closeAllowed === true )
        {
            doSetPrivacyRead() ;
        }
    }

    const onScrollBottomReached = () =>
    {
        setCloseAllowed(true);
        setButtonState('') ;
    }

    const onFocus = ( e ) =>
    {
        e.preventDefault();
        e.target.focus({preventScroll: true});
    }

    const appName = getVariant( authority_id, VariantString.APPLICATION_NAME ) ;

    return (
        <ModalContentWrapper onScrollBottomReached={onScrollBottomReached} >
            <div className='privacy-scroller'>
                <h1 style={{textAlign: 'center'}}>School Readiness Passport Acceptable Use Policy (Staff)</h1>
                <h2 style={{textAlign: 'center'}}>Welcome to the School Readiness Passport System</h2>
                <h2 style={{textAlign: 'center'}}>Please read the notice below which defines expected usage guidelines and behaviour expected from system users.</h2>
                <h2 style={{textAlign: 'center'}}>In addition, a privacy policy notice is available when you login which should be downloaded and made available
                    to parents to inform them that you are using the {appName} as a transition and assessment tool.</h2>
                <ul>
                    <li>All users must take responsibility for their own use of new technologies, making sure that they use technology safely, responsibly and legally.</li>
                    <li>All users must be active participants in e-safety education, taking personal responsibility for their awareness of the opportunities and risks posed by new technologies.</li>
                    <li>No applications or services accessed by users may be used to bring the provider, or its members, into disrepute.</li>
                    <li>All users have a responsibility to report any known misuses of technology, including the unacceptable behaviours of others</li>
                    <li>All users have a duty to respect the technical safeguards, which are in place. Any attempt to breach technical safeguards, conceal network identities, or gain unauthorised access to systems and services, is unacceptable.</li>
                    <li>All users have a duty to report failings in technical safeguards, which may become apparent when using the systems and services.</li>
                    <li>All users have a duty to protect their passwords and personal network logins, and should log off the network when leaving workstations unattended. Any attempts to access, corrupt or destroy other users’ data, or compromise the privacy of others in any way, using any technology, is unacceptable.</li>
                    <li>All users should understand that system activity may be logged for audit purposes.</li>
                    <li>All users should be aware that in certain circumstances where unacceptable use is suspected, enhanced monitoring and procedures may come into action.</li>
                    <li>All users must take responsibility for reading and upholding the standards laid out in the Acceptable Use Policy.</li>
                </ul>
            </div>

            <div className="row" style={{textAlign: 'center'}}>
                <div className='col-md-12'>
                    <button  disabled={buttonState} onClick={onClickCancel} style={{ marginLeft: '15px'}} className="btn btn-icon btn-green btn-icon-right btn-small">I've Read It!<i className="et-check"/></button>
                </div>
            </div>

        </ModalContentWrapper>
    )
}

export default ModalPrivacyStatement ;